import { Box } from '@mui/material';
import EChartsReact, { EChartsReactProps } from 'echarts-for-react';
import React from 'react';

const BarChart: React.FC<EChartsReactProps> = ({ option, ...props }) => {
    const baseOption = React.useMemo(
        () => ({
            xAxis: {
                type: 'category',
                data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            },
            yAxis: {
                type: 'value',
            },
            series: [
                {
                    data: [120, 200, 150, 80, 70, 110, 130],
                    type: 'bar',
                },
            ],
        }),
        []
    );
    const mergedOption = React.useMemo(
        () => ({
            ...baseOption,
            ...option,
        }),
        [baseOption, option]
    );
    return (
        <Box>
            <EChartsReact option={mergedOption} {...props} />
        </Box>
    );
};

export default BarChart;
